import { render, staticRenderFns } from "./LanguagePickerComponent.vue?vue&type=template&id=981f1fc6&scoped=true&"
import script from "./LanguagePickerComponent.vue?vue&type=script&lang=ts&"
export * from "./LanguagePickerComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LanguagePickerComponent.vue?vue&type=style&index=0&id=981f1fc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981f1fc6",
  null
  
)

export default component.exports